import React from "react";
const Bell = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            d="M12 15H6m6 0h5l-1.405-1.405A2.032 2.032 0 0 1 15 12.158V9a6.001 6.001 0 0 0-4-5.659V3a2 2 0 1 0-4 0v.341C4.67 4.165 3 6.388 3 9v3.159c0 .538-.214 1.055-.595 1.436L1 15h11Zm0 0v1a3 3 0 0 1-6 0v-1h6Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Bell;
